import * as angular from 'angular';
import { CreditGapsWizardGradPlanTableComponent } from './credit-gaps-wizard-grad-plan-table.component';

export const CreditGapsWizardGradPlanTableModule = angular
  .module('creditGapsWizardGradPlanTableModule', [])
  .component('creditGapsWizardGradPlanTable', CreditGapsWizardGradPlanTableComponent).name;
